import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgBreakGlyphSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M34.51 9.68H31.7v-.93c0-.41-.34-.75-.75-.75s-.75.34-.75.75v.93H17.79v-.93a.749.749 0 1 0-1.5 0v.93h-2.8A5.5 5.5 0 0 0 8 15.17v19.34C8 37.54 10.46 40 13.49 40h21.03c3.03 0 5.49-2.46 5.49-5.49V15.17c-.01-3.02-2.47-5.49-5.5-5.49Zm-21.02 1.5h2.81v.76c0 .41.34.75.75.75s.75-.34.75-.75v-.76h12.41v.7c0 .41.34.75.75.75s.75-.34.75-.75v-.7h2.81c2.2 0 3.99 1.79 3.99 3.99v5.86h-29v-5.86a3.98 3.98 0 0 1 3.98-3.99ZM34.51 38.5H13.49c-2.2 0-3.99-1.79-3.99-3.99V22.53h29v11.98c0 2.2-1.79 3.99-3.99 3.99Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "M17.04 18.25c.78 0 1.42-.64 1.42-1.42a1.419 1.419 0 1 0-1.42 1.42ZM30.96 18.25c.78 0 1.42-.64 1.42-1.42a1.419 1.419 0 1 0-2.84 0c-.01.79.63 1.42 1.42 1.42ZM29.71 30.51l2.56-4.06c.22-.35.12-.81-.24-1.03a.739.739 0 0 0-1.03.24l-2.17 3.45-2.17-3.45a.747.747 0 1 0-1.27.79l2.56 4.06-2.56 4.06c-.22.35-.12.81.24 1.03.12.08.26.12.4.12.25 0 .49-.12.64-.35l2.18-3.45 2.18 3.45a.744.744 0 0 0 1.04.23c.35-.22.46-.68.24-1.03l-2.6-4.06ZM21.48 25.5c-1.78 1.62-2.7 4.33-3.16 6.43-.4-.61-.96-1.14-1.72-1.4-.4-.13-.82.08-.95.48-.13.39.08.82.48.95 1.15.38 1.65 2.38 1.75 3.11.05.38.37.65.74.65h.02c.39-.01.7-.32.72-.7 0-.06.41-5.95 3.12-8.42.31-.28.33-.75.05-1.06-.26-.3-.74-.32-1.05-.04Z",
    fill: "currentColor"
  }));
}

export { SvgBreakGlyphSecondary as default };
